import React from 'react'
import Main from '../../Main'
import Button from '../../shared/form/Button'

const EmailChild = props => {
  return (
    <Main>
      <div className="island">
        <p>Your sponsored child will feel thrilled and delighted when they feel your love and support in a message directly from you. Write them a message today, and let them know they're in your thoughts and prayers.</p>

        <form onSubmit={props.submit}>
          <div className="form-item">
            <div className="resizable-textarea">
              <textarea id="edit-mail-body" name="message" cols="60" rows="5" className="form-textarea required" onChange={props.change} value={props.body}></textarea>
            </div>
          </div>

          <div className="for-item">
            <div className="row">
              <div className="col-md-6">
                <h2>Send a Photo <span>(optional)</span></h2>
                <div className="form-item form-type-file form-item-files-mail-image">
                <input type="file" id="edit-mail-image" name="photo" onChange={props.change} size="60" className="form-file" tabIndex="-1" style={{position: 'absolute', clip: 'rect(0px 0px 0px 0px)'}} />

                  <div className="bootstrap-filestyle input-group">
                    <span className="group-span-filestyle " tabIndex="0">
                      <label htmlFor="edit-mail-image" className="btn">Upload Photo
                        <br />
                        {props.fname}
                      </label>
                    </span>
                  </div>

                  <div className="description">Allowed photo extensions: jpg, jpeg, png, gif</div>
                </div>
              </div>

              <div className="col-md-6 text-right">
                <br/><br/>
                <Button loading={props.loading}>Send Message</Button>
              </div>
            </div>
          </div>
        </form>

      </div>
    </Main>
  )
}

export default EmailChild
